import { render, staticRenderFns } from "./student-assessments.vue?vue&type=template&id=c2320764&scoped=true&"
import script from "./student-assessments.vue?vue&type=script&lang=js&"
export * from "./student-assessments.vue?vue&type=script&lang=js&"
import style0 from "./student-assessments.vue?vue&type=style&index=0&id=c2320764&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2320764",
  null
  
)

export default component.exports